"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureModal = void 0;
var React = __importStar(require("react"));
var react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
var Context_1 = require("../Context");
var TabNames;
(function (TabNames) {
    TabNames["Type"] = "Type";
    TabNames["Sign"] = "Sign";
    TabNames["Image"] = "Image";
})(TabNames || (TabNames = {}));
var colorResolver = function (selected, match) {
    return selected === match ? "#fa3fb8" : "#000";
};
var signaturePadHeight = 300;
function SignatureModal(props) {
    var color = props.color, size = props.size, onClose = props.onClose;
    var containerRef = React.useRef();
    var signatureRef = React.useRef();
    var _a = React.useState(), containerDims = _a[0], setContainerDims = _a[1];
    var _b = React.useState(TabNames.Sign), selectedTab = _b[0], setSelectedTab = _b[1];
    var _c = React.useState(""), text = _c[0], setText = _c[1];
    var ctx = React.useContext(Context_1.GlobalContext);
    var handleSignature = ctx.handleSignature;
    var updateContainerSize = function () {
        var _a, _b;
        var containerRect = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (containerRect) {
            setContainerDims({
                width: containerRect.width,
                height: containerRect.height
            });
            (_b = signatureRef.current) === null || _b === void 0 ? void 0 : _b.clear();
        }
    };
    React.useEffect(function () {
        window.addEventListener("resize", updateContainerSize);
        updateContainerSize();
        return window.removeEventListener("resize", updateContainerSize);
    }, []);
    var defaultSize = 12; // Use this as the basis
    var scale = size / defaultSize;
    var minWidth = 0.5 * scale; // These are the defaults
    var maxWidth = 2.5 * scale; // These are the defaults
    var handleApply = function () {
        var _a, _b;
        if (text) {
            handleSignature({
                text: text,
                color: color
            }, "text");
        }
        else {
            var signImage = (_b = (_a = signatureRef.current) === null || _a === void 0 ? void 0 : _a.getTrimmedCanvas()) === null || _b === void 0 ? void 0 : _b.toDataURL("image/png");
            handleSignature(signImage);
        }
    };
    return (React.createElement("div", { style: { position: "relative", zIndex: 99999 } },
        React.createElement("div", { className: "d-flex justify-content-center", style: { textAlign: "center" } },
            React.createElement("div", { onClick: function () { return setSelectedTab(TabNames.Sign); }, className: "mr-4 pb-1", style: {
                    borderBottom: "2px solid " + colorResolver(selectedTab, TabNames.Sign),
                    color: colorResolver(selectedTab, TabNames.Sign)
                } },
                React.createElement("i", { className: "fas fa-pen-fancy" }),
                React.createElement("div", null, "Sign")),
            React.createElement("div", { onClick: function () { return setSelectedTab(TabNames.Type); }, className: "mr-4 pb-1", style: {
                    borderBottom: "2px solid " + colorResolver(selectedTab, TabNames.Type),
                    color: colorResolver(selectedTab, TabNames.Type)
                } },
                React.createElement("i", { className: "fas fa-font" }),
                React.createElement("div", null, "Type"))),
        selectedTab === TabNames.Type && (React.createElement("div", { style: {
                border: "1px solid #eaeaea",
                borderRadius: 8,
                height: signaturePadHeight
            }, className: "p-5" },
            React.createElement("div", { style: { textAlign: "center" } },
                React.createElement("input", { type: "text", className: "form-control custom-form-control", onChange: function (e) { return setText(e.target.value); } })))),
        selectedTab === TabNames.Sign && (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: containerRef, style: {
                    border: "1px solid #eaeaea",
                    borderRadius: 8,
                    backgroundImage: "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%),linear-gradient(135deg, transparent 75%, #ccc 75%)",
                    backgroundSize: "25px 25px",
                    backgroundPosition: "0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px"
                } },
                React.createElement(react_signature_canvas_1.default, { ref: signatureRef, penColor: color, minWidth: minWidth, maxWidth: maxWidth, canvasProps: {
                        width: containerDims === null || containerDims === void 0 ? void 0 : containerDims.width,
                        height: signaturePadHeight,
                        className: "sigCanvas"
                    } }),
                React.createElement("div", { style: {
                        border: "2px solid blue",
                        position: "relative",
                        top: -signaturePadHeight / 3
                    } })),
            React.createElement("label", null,
                React.createElement("input", { type: "checkbox" }),
                " Save Signature"))),
        selectedTab === TabNames.Image && React.createElement("div", null, "Image"),
        React.createElement("div", { className: "text-center mt-3" },
            React.createElement("button", { onClick: function () {
                    handleApply();
                    onClose();
                }, className: "btn btn-primary mx-2" }, "Apply"),
            React.createElement("button", { onClick: onClose, className: "btn btn-secondary mx-2" }, "Cancel"))));
}
exports.SignatureModal = SignatureModal;
